import { sortAppointmentsByTimeAsc } from '.';

export default function getWednesdayAppointmets(appointments) {
    const filterWednesdayAppointments = appointments.filter(
        item => new Date(item.data.date).getDay() === 3,
    );
    return sortAppointmentsByTimeAsc(filterWednesdayAppointments);
}
